export default "__VITE_ASSET__4abddeee__"